export var createEventTargetFactory = function (window) {
    return function () {
        if (window === null) {
            throw new Error('A native EventTarget could not be created.');
        }
        return window.document.createElement('p');
    };
};
//# sourceMappingURL=event-target-factory.js.map
